module.exports = __webpack_public_path__ + "img/role01.56e3ce0e.png";